var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon21(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(-190 -3751)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(190 3751)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_Shuttle_bus",
    d: "M4.714,4A3.729,3.729,0,0,0,1,7.706V20.059a1.237,1.237,0,0,0,1.238,1.235h1.3a4.313,4.313,0,0,0,8.541,0h3.84a4.313,4.313,0,0,0,8.541,0h1.3A1.237,1.237,0,0,0,27,20.059V12.647A1.233,1.233,0,0,0,26.816,12L22.962,5.761A3.717,3.717,0,0,0,19.8,4Zm0,2.471H8.429v4.941H3.476V7.706A1.217,1.217,0,0,1,4.714,6.471Zm6.19,0h4.952v4.941H10.9Zm7.429,0H19.8a1.23,1.23,0,0,1,1.052.586s0,0,0,0l2.691,4.352H18.333ZM3.476,13.882H24.524v4.941h-.44a4.3,4.3,0,0,0-7.786,0H11.7a4.3,4.3,0,0,0-7.786,0h-.44ZM7.81,18.824a1.853,1.853,0,1,1-1.857,1.853A1.837,1.837,0,0,1,7.81,18.824Zm12.381,0a1.853,1.853,0,1,1-1.857,1.853A1.837,1.837,0,0,1,20.19,18.824Z",
    transform: "translate(206 3767)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon21);
export default __webpack_public_path__ + "static/media/facilityIcon21.37016c0b022bb06e202db87f1a0a276a.svg";
export { ForwardRef as ReactComponent };